import __request__ from "routing/request";
export function loggers() {
  return __request__("GET", "/system/loggers", null, {}, {
    "Accept": ["application/json"]
  });
}
export function messages(limit = 1e3) {
  return __request__("GET", "/system/loggers/messages/recent", null, { "limit": limit }, {
    "Accept": ["text/plain"]
  });
}
export function subsystems() {
  return __request__("GET", "/system/loggers/subsystems", null, {}, {
    "Accept": ["application/json"]
  });
}
export function setSubsystemLoggerLevel(subsystem, level) {
  return __request__("PUT", `/system/loggers/subsystems/${subsystem}/level/${level}`, null, {}, {
    "Accept": []
  });
}
export function setSingleLoggerLevel(loggerName, level) {
  return __request__("PUT", `/system/loggers/${loggerName}/level/${level}`, null, {}, {
    "Accept": []
  });
}
